import React from 'react';
import cx from 'classnames';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import * as Icons from '@material-ui/icons';

const MessageContext = ({ desc, icon, variant, show, productId, targetId, position, target }) => {
    const Icon = icon && Icons[icon];
    const alertClasses = cx(
        'message__bg',
        {
            [`message__bg--${variant}`]: variant,
        },
        {
            [`message__inside`]: target === 'inside' && targetId === productId,
        },
    );
    const containerClasses = cx('container__message', {
        'container__message--inside': target === 'inside' && targetId === productId,
        hide: !(show && target === position),
    });

    return (
        <Container className={containerClasses}>
            <Alert variant={variant} className={alertClasses}>
                <div className="message__desc">
                    {icon && <Icon />}
                    {desc && <div dangerouslySetInnerHTML={{ __html: desc }} />}
                </div>
            </Alert>
        </Container>
    );
};

export default MessageContext;
